import i18n from '@/lang';
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
/* this file is transformed by vux-loader */
/* eslint-disable */
import "core-js/modules/es.object.to-string.js";
export default [{
  path: '/serviceMall',
  name: 'serviceMall',
  component: function component() {
    return import('@/pages/serviceMall/index');
  },
  children: [{
    path: 'home',
    name: 'ServiceMallHome',
    component: function component() {
      return import('@/pages/serviceMall/home/index');
    },
    meta: {
      name: i18n.tc("0")
    }
  }, {
    path: 'mine',
    name: 'ServiceMallMine',
    component: function component() {
      return import('@/pages/serviceMall/Mine/index');
    },
    meta: {
      name: i18n.tc("119")
    }
  }, {
    path: 'classification',
    name: 'classification',
    component: function component() {
      return import('@/pages/serviceMall/classification/index');
    },
    meta: {
      name: i18n.tc("120")
    }
  }, {
    path: 'shoppingCart',
    name: 'shoppingCart',
    component: function component() {
      return import('@/pages/serviceMall/shoppingCart/index');
    },
    meta: {
      name: i18n.tc("121")
    }
  }, {
    path: 'classification/classificationList',
    name: 'classificationList',
    component: function component() {
      return import('@/pages/serviceMall/classification/classificationList');
    },
    meta: {
      name: i18n.tc("122")
    }
  }, {
    path: 'classification/classificationList/:id',
    name: 'productDetails',
    component: function component() {
      return import('@/pages/serviceMall/classification/productDetails');
    },
    meta: {
      name: i18n.tc("123")
    }
  }, {
    path: 'determineOrder',
    name: 'determineOrder',
    component: function component() {
      return import('@/pages/serviceMall/shoppingCart/determineOrder');
    },
    meta: {
      name: i18n.tc("124")
    }
  }, {
    path: 'offline',
    name: 'offline',
    component: function component() {
      return import('@/pages/serviceMall/shoppingCart/offline');
    },
    meta: {
      name: i18n.tc("125")
    }
  }, {
    path: 'address',
    name: 'address',
    component: function component() {
      return import('@/pages/serviceMall/Mine/address/list');
    },
    meta: {
      name: i18n.tc("126")
    }
  }, {
    path: 'myOrder',
    name: 'myOrder',
    component: function component() {
      return import('@/pages/serviceMall/Mine/myOrder');
    },
    meta: {
      name: i18n.tc("127")
    }
  }, {
    path: 'myOrder/:id',
    name: 'orderDetails',
    props: true,
    component: function component() {
      return import('@/pages/serviceMall/Mine/orderDetails');
    },
    meta: {
      name: i18n.tc("128")
    }
  }]
}];